import React from "react";
import { CustomeCard } from "../../components/card/CustomCard";
import Ajaan from "../../assets/images/Ajaan.jpg";
const About = () => {
  return (
    <div className="App">
      <div className="article">
        <h2></h2>
        {/* <p>
        Gosiṅgārāma Mountain Hermitage Trust
        </p> */}
          <CustomeCard
          title={'Gosiṅgārāma Mountain Hermitage Trust'}
          description={`The vision statement from the trust deed of the Gosiṅgārāma Mountain
          Hermitage Trust as a template for how this way of practice may be
          integrated into the modern world.`}
          file= "./pdfs/trust/The Gosingārāma Mountain Hermitage_Trust Vision Statement.pdf"
    fileName = 'The Gosiṅgārāma Mountain Hermitage_Trust Vision Statement'
    fileSize = '180KB'
          size={'sm'}/>
      </div>
        <div className="article">
              <h1>About the Author</h1>
              <img src={Ajaan} alt="Ajaan Nico" />
              <p>
                <span className="dropcap">A</span>
                <span className="sc">jaan Nico (Phra Jotidhammo)</span> was born in
                the year of the Water Ox on the 3<sup>rd</sup> of July, 1973.
                Initially ordaining in the Dhammayuttika Nikāya as a{" "}
                <span>sāmaṇera</span> with Tan Chao Khun Mahā Samai Sukhasumiddho
                (Phra Thepsīlabhorn) as Preceptor in 1995.
              </p>
              <p>
                Realising the need for more structured training, Ajaan Nico took
                <span> upasampadā</span> (higher ordination) on the 3<sup>rd</sup> of
                January, 1999, in the Wat Nong Pa Pong Lineage of Luang Por Chah
                Subhaddo (Phra Bodhiñāṇa).
              </p>
              <p>
                After five years training in a Wat Pa Pong branch monastery in
                Australia, Ajaan Nico sought out secluded places for practice in
                Australia, Sri Lanka, and Thailand. In 2008, establishing{" "}
                <span>Isigiri kuṭi</span> in the Peak Wilderness Sanctuary of Sri
                Lanka where he spent 15 <span>vassa </span>
                primarily in solitary retreat.
              </p>
              <p>
                After 27 <span>vassa</span> as a <span>bhikkhu</span>, Ajaan Nico
                relocated and renovated a remote cave (<span>Aññacitta lena</span>) in
                the Knuckles mountain range to enter a long-term retreat. Before
                entering retreat, Gosiṅgārāma Mountain Hemitage was incorporated as a
                charitable trust to establish, build, and support Hermitages and
                Mountain Retreats where a mode of practice that is grounded solely in
                the principles of <span>dhamma-vinaya</span> in their archetypal
                orientation as a vehicle for mental development (
                <span>citta-bhāvanā</span>) and the realisation of final knowledge (
                <span>aññā</span>) may be cultivated by sincere practitioners
                possessing a profound appreciation of solitude.
              </p>
              {/* <p>
                Gosiṅgārāma Mountain Hermitage is establishing solitary retreat
                facilities for well-trained <span>nissayamuttaka bhikkhus</span>{" "}
                (monks freed from dependence) in the <span>kammaṭṭhāna</span> lineage
                of Luang Pu Mun Bhūridatta Mahāthera who wish to cultivate this way of
                practice in remote, mountainous cloud forest.
              </p> */}
              <br />
              <br />
              <div className="quotation">
                <span>
                  I do praise bonding with lodgings that are quiet, <br/>free of noise,
                  with an air of isolation, <br/>remote from human beings,<br/> and appropriate
                  for retreat...
                </span>
                <div style={{ marginTop: "8px" }}>
                  <span>AN VIII 61</span>
                </div>
              </div>
              <div className="end-mark">
                <hr />
              </div>
            </div>
    </div>
  );
};

export default About;


// Audio Dhamma discourses

// These Dhamma discourses are largely recordings from recent retreats that focus upon meditation practice and the Buddhist path through questions by the retreatants.